'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var styled = _interopDefault(require('styled-components'));

var Divider = styled.hr.withConfig({
  componentId: "sc-1pjecqb-0"
})(function (_ref) {
  var _ref$s = _ref.s,
    s = _ref$s === void 0 ? {} : _ref$s;
  return {
    margin: (s === null || s === void 0 ? void 0 : s.margin) || '1.25rem 0',
    border: (s === null || s === void 0 ? void 0 : s.border) || '1px solid #e0e0e0',
    borderTop: 'none',
    borderRight: 'none',
    borderLeft: 'none'
  };
});

exports.default = Divider;
